<template>
  <template v-if="!loading && isAuthenticated">
    <SideBarMobile
      :sidebarLinks="displaySidebar"
      :lower-sidebar-links="lowerDisplaySidebar"
      v-model:isHamburgerOpen="isHamburgerOpen"
    />
    <top-navbar v-model:isHamburgerOpen="isHamburgerOpen" />
    <SideBar
      :sidebarLinks="displaySidebar"
      :lower-sidebar-links="lowerDisplaySidebar"
    />

    <FlashMessage
      :message="flashStatus.message"
      :show="flashStatus.show"
      :type="flashStatus.type"
      :fadeOut="flashStatus.fadeout"
      :manualLink="flashStatus.manualLink"
      @hide="hideFlash"
    />

    <v-main>
      <template v-if="contentLoading">
        <div class="contentLoading">
          <div>
            <label>読み込み中</label>
          </div>
        </div>
      </template>
      <router-view
        :showFlash="showFlash"
        :switchContentLoading="switchContentLoading"
      />
    </v-main>

    <content-footer />
  </template>
  <template v-else>
    <div
      class="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8"
    >
      <div class="max-w-md w-full space-y-8">
        <v-loader-animation
          :text="'text-black'"
          :loading-text-style="'text-black text-lg'"
        />
      </div>
    </div>
  </template>
</template>
<script setup lang="ts">
import TopNavbar from '@/layout/components/topNavbar/TopNavbar.vue';
import ContentFooter from '@/layout/components/ContentFooter.vue';
import vLoaderAnimation from '@/components/template/v-loader-animation.vue';
import { useAuth } from '@/services/user/Auth0UserProvider';
import FlashMessage from '@/components/FlashMessage';
import { reactive, Ref, ref } from 'vue';
import { getAccessCheckerInstance } from '@/router/accessChecker';
import SidebarLinksCreator, { SidebarLink } from '@/router/sidebarLinksCreator';
import SideBar from '@/layout/components/sidebar/SideBar.vue';
import SideBarMobile from './components/sidebar/SideBarMobile.vue';
import Api from "@/services/api/ApiServiceFabrick";
import i18n from '@/lang/i18n';

const { isAuthenticated, loading } = useAuth();
const flashStatus = reactive({
  message: '',
  type: '',
  fadeout: true,
  show: false,
  manualLink: '',
});
const contentLoading = ref(false);
const isHamburgerOpen = ref(false);
const displaySidebar: Ref<SidebarLink[]> = ref([]);
const lowerDisplaySidebar: Ref<SidebarLink[]> = ref([
  {
    name: i18n.global.t('sideMenue.support'),
    path: process.env.VUE_APP_SUPPORT_LINK,
    icon: 'mdi-face-agent',
    extarnal_link: true,
    childLinks: [],
  },
]);

const getSideBarLinks = async () => {
  return new SidebarLinksCreator(
    await getAccessCheckerInstance(),
    await Api().getSelfOffice()
  ).getLinks;
};
(async () => {
  displaySidebar.value = await getSideBarLinks();
})();

const hideFlash = () => {
  flashStatus.show = false;
};
const showFlash = (message: string, type: string, fadeout: boolean, manualLink = '') => {
  moveToTop();
  flashStatus.message = message;
  flashStatus.type = type;
  flashStatus.fadeout = fadeout;
  flashStatus.show = true;
  flashStatus.manualLink = manualLink;
};
const moveToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  });
};
const switchContentLoading = (bool: boolean) => {
  contentLoading.value = bool;
};
</script>
<style scoped>
.contentloading {
  position: relative;
  height: 100%;
  width: 100%;
}

.contentLoading > div {
  position: absolute;
  background-color: rgba(80, 80, 80, 0.5);
  height: 100%;
  width: 100%;
  z-index: 1001;
}
.contentLoading > div > label {
  font-weight: bold;
  color: white;
  position: absolute;
  top: 300px;
  left:40%;
  transform: translateY(-50%) translateX(-50%);
}
</style>
